import React, { useState } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import SubscriptionOptions from './SubscriptionOptions';
import PaymentService from '../services/payment.service';
import './PaymentForm.css';

const paymentService = new PaymentService();

const PaymentForm = ({ handlePayment }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState('basic');
  const [billingInfo, setBillingInfo] = useState({
    name: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    postalCode: '',
    country: '', // Ensure a valid country code is selected
  });

  const handleChange = (event) => {
    setBillingInfo({
      ...billingInfo,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    try {
      // Step 1: Create customer on backend
      const customerResponse = await paymentService.createCustomer(billingInfo);
      if (customerResponse.error) {
        setError(customerResponse.error);
        return;
      }

      // Step 2: Create payment method on Stripe
      const cardElement = elements.getElement(CardElement);
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
        billing_details: {
          name: billingInfo.name,
          address: {
            line1: billingInfo.addressLine1,
            line2: billingInfo.addressLine2,
            city: billingInfo.city,
            state: billingInfo.state,
            postal_code: billingInfo.postalCode,
            country: billingInfo.country,
          },
        },
      });

      if (error) {
        setError(error.message);
        return;
      }

      // Step 3: Send customerId, paymentMethodId, and selected plan to backend to create subscription
      const subscriptionResponse = await paymentService.createSubscription( paymentMethod.id, selectedPlan);
      if (subscriptionResponse.error) {
        setError(subscriptionResponse.error);
      } else {
        handlePayment(subscriptionResponse);
        window.location.hash = '/notes';
      }
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="payment-form">
      <SubscriptionOptions selectedPlan={selectedPlan} onSelectPlan={setSelectedPlan} />

      <div className="billing-info">
        <h2>Billing Information</h2>
        <label>
          Name
          <input
            type="text"
            name="name"
            value={billingInfo.name}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Address Line 1
          <input
            type="text"
            name="addressLine1"
            value={billingInfo.addressLine1}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Address Line 2
          <input
            type="text"
            name="addressLine2"
            value={billingInfo.addressLine2}
            onChange={handleChange}
          />
        </label>
        <label>
          City
          <input
            type="text"
            name="city"
            value={billingInfo.city}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          State
          <input
            type="text"
            name="state"
            value={billingInfo.state}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Postal Code
          <input
            type="text"
            name="postalCode"
            value={billingInfo.postalCode}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Country
          <select
            name="country"
            value={billingInfo.country}
            onChange={handleChange}
            required
          >
            <option value="">Select a country</option>
            <option value="US">United States</option>
            {/* <option value="CA">Canada</option>
            <option value="GB">United Kingdom</option>
            <option value="AU">Australia</option> */}
            {/* Add more countries as needed */}
          </select>
        </label>
      </div>

      <div className="card-details">
        <h2>Card Details</h2>
        <label>
          Card details
          <CardElement className="StripeElement" />
        </label>
      </div>

      {error && <div className="error">{error}</div>}
      <button type="submit" disabled={!stripe}>
        Pay
      </button>
    </form>
  );
};

export default PaymentForm;
